import { gql } from '@apollo/client';

import { studentFragment } from '../fragments';

export default gql`
  query SearchStudent($courseId: String!, $query: String) {
    student(courseId: $courseId, query: $query)
      @rest(type: "Student", path: "students?query={args.query}") {
      ...Student
    }
  }
  ${studentFragment}
`;
